// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Social-module__font-s-10___VR9Mg {
  font-size: 10px !important;
}

.Social-module__font-s-12___ki1k9 {
  font-size: 12px !important;
}

.Social-module__font-s-13___S_zj2 {
  font-size: 13px !important;
}

.Social-module__font-s-14___B6ANJ {
  font-size: 14px !important;
}

.Social-module__font-s-15___fsEM9 {
  font-size: 15px !important;
}

.Social-module__font-s-16___WRtI1 {
  font-size: 16px !important;
}

.Social-module__font-s-18___QOOOi {
  font-size: 18px !important;
}

.Social-module__font-s-20___yw2wv {
  font-size: 20px !important;
}

.Social-module__font-s-22___BmeVY {
  font-size: 22px !important;
}

.Social-module__font-s-28___k9TCS {
  font-size: 28px !important;
}

.Social-module__font-w-400___FAZZS {
  font-weight: 400 !important;
}

.Social-module__font-w-500___DqlK9 {
  font-weight: 500 !important;
}

.Social-module__font-w-600___wh0_l {
  font-weight: 600 !important;
}

.Social-module__font-w-700___Q9PTm {
  font-weight: 700 !important;
}

.Social-module__p-5___B3wsu {
  padding: 5px !important;
}

.Social-module__p-12___LbvDX {
  padding: 12px !important;
}

.Social-module__p-16___BBlqH {
  padding: 16px !important;
}

.Social-module__p-30___t5NWZ {
  padding: 30px !important;
}

.Social-module__p-b-0___AQouN {
  padding-bottom: 0 !important;
}

.Social-module__p-b-5___hjoPV {
  padding-bottom: 5px !important;
}

.Social-module__p-b-10___LFOxA {
  padding-bottom: 10px !important;
}

.Social-module__p-b-12___x8fLj {
  padding-bottom: 12px !important;
}

.Social-module__p-b-16___h7uLQ {
  padding-bottom: 16px !important;
}

.Social-module__p-b-18___KA25L {
  padding-bottom: 18px !important;
}

.Social-module__p-b-20___Ie3kF {
  padding-bottom: 20px !important;
}

.Social-module__p-b-25___YN2yV {
  padding-bottom: 25px !important;
}

.Social-module__p-b-30___JfPwB {
  padding-bottom: 30px !important;
}

.Social-module__p-b-50___gudsi {
  padding-bottom: 50px !important;
}

.Social-module__p-t-0___HfJN1 {
  padding-top: 0 !important;
}

.Social-module__p-t-12___idW5R {
  padding-top: 12px !important;
}

.Social-module__p-t-16___pUpMv {
  padding-top: 16px !important;
}

.Social-module__p-t-18___O5i5L {
  padding-top: 18px !important;
}

.Social-module__p-t-20___ZkuHf {
  padding-top: 20px !important;
}

.Social-module__p-t-30___B5y15 {
  padding-top: 30px !important;
}

.Social-module__p-t-40___WhVOJ {
  padding-top: 40px !important;
}

.Social-module__p-t-50___AMwpL {
  padding-top: 50px !important;
}

.Social-module__p-l-20___ML1Qb {
  padding-left: 20px !important;
}

.Social-module__p-l-30___NYTW1 {
  padding-left: 30px !important;
}

.Social-module__p-l-40___FywCN {
  padding-left: 40px !important;
}

.Social-module__p-r-16___PuFRt {
  padding-right: 16px !important;
}

.Social-module__p-r-20___YfENY {
  padding-right: 20px !important;
}

.Social-module__p-r-30___Da4fQ {
  padding-right: 30px !important;
}

.Social-module__p-r-50___rwzgc {
  padding-right: 50px !important;
}

.Social-module__p-r-60___G8KQ5 {
  padding-right: 60px !important;
}

.Social-module__m-b-1___pFkN4 {
  margin-bottom: 1px !important;
}

.Social-module__m-b-2___WQSrU {
  margin-bottom: 2px !important;
}

.Social-module__m-b-6___epfm7 {
  margin-bottom: 6px !important;
}

.Social-module__m-b-8___z0wDl {
  margin-bottom: 8px !important;
}

.Social-module__m-b-10___jpIX0 {
  margin-bottom: 10px !important;
}

.Social-module__m-b-14___EfpZ3 {
  margin-bottom: 14px !important;
}

.Social-module__m-b-16___Yj1Xm {
  margin-bottom: 16px !important;
}

.Social-module__m-b-20___jfKqX {
  margin-bottom: 20px !important;
}

.Social-module__m-b-22___JHKEX {
  margin-bottom: 22px !important;
}

.Social-module__m-b-24___zZvmY {
  margin-bottom: 24px !important;
}

.Social-module__m-b-30___zqNKu {
  margin-bottom: 30px !important;
}

.Social-module__m-b-32___GVWEk {
  margin-bottom: 32px !important;
}

.Social-module__m-b-40___vhfLM {
  margin-bottom: 40px !important;
}

.Social-module__m-t-2___a8UrR {
  margin-top: 2px !important;
}

.Social-module__m-t-3___tOXya {
  margin-top: 3px !important;
}

.Social-module__m-t-4___SN3bl {
  margin-top: 4px !important;
}

.Social-module__m-t-5___U5kWv {
  margin-top: 5px !important;
}

.Social-module__m-t-8___IFngg {
  margin-top: 8px !important;
}

.Social-module__m-t-10___KtiIK {
  margin-top: 10px !important;
}

.Social-module__m-t-15___Eca0V {
  margin-top: 15px !important;
}

.Social-module__m-t-16___IJq2C {
  margin-top: 16px !important;
}

.Social-module__m-t-20___VZagB {
  margin-top: 20px !important;
}

.Social-module__m-t-22___jA9D6 {
  margin-top: 22px !important;
}

.Social-module__m-t-30___HSeAV {
  margin-top: 30px !important;
}

.Social-module__m-t-32___WIbEG {
  margin-top: 32px !important;
}

.Social-module__m-l-auto___bLJwC {
  margin-left: auto !important;
}

.Social-module__m-l-4___Ah_8f {
  margin-left: 4px !important;
}

.Social-module__m-l-5___bE4Sj {
  margin-left: 5px !important;
}

.Social-module__m-l-6___iiLe0 {
  margin-left: 6px !important;
}

.Social-module__m-l-8___VK6BS {
  margin-left: 8px !important;
}

.Social-module__m-l-10___v9JJI {
  margin-left: 10px !important;
}

.Social-module__m-l-16___qfbvU {
  margin-left: 16px !important;
}

.Social-module__m-l-20___hIUaq {
  margin-left: 20px !important;
}

.Social-module__m-l-24___cSa87 {
  margin-left: 24px !important;
}

.Social-module__m-l-30___vOX9A {
  margin-left: 30px !important;
}

.Social-module__m-l-35___VSkEM {
  margin-left: 35px !important;
}

.Social-module__m-l-40___hrwmu {
  margin-left: 40px !important;
}

.Social-module__m-r-8___Tk5YJ {
  margin-right: 8px !important;
}

.Social-module__m-r-10___ujXVM {
  margin-right: 10px !important;
}

.Social-module__m-r-16___wcyv9 {
  margin-right: 16px !important;
}

.Social-module__m-r-20___fHtXR {
  margin-right: 20px !important;
}

.Social-module__m-r-24___hcOsX {
  margin-right: 24px !important;
}

.Social-module__m-r-30___PqnDl {
  margin-right: 30px !important;
}

.Social-module__m-r-40___oYxhH {
  margin-right: 40px !important;
}

.Social-module__border-r-3___WcB8J {
  border-radius: 3px !important;
}

.Social-module__border-r-4___uUjeb {
  border-radius: 4px !important;
}

.Social-module__border-r-6___Iacj0 {
  border-radius: 6px !important;
}

.Social-module__border-r-10___zN6hX {
  border-radius: 10px !important;
}

.Social-module__border-r-12___ZJ2To {
  border-radius: 12px !important;
}

.Social-module__border-r-16___OKFpl {
  border-radius: 16px !important;
}

.Social-module__border-r-50___FpW9u {
  border-radius: 50% !important;
}

.Social-module__primary-border___QeYc1 {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.Social-module__primary-border-b___v4gEe {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.Social-module__primary-border-t___jOwru {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.Social-module__primary-border-l___JsPEr {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.Social-module__primary-border-r___yN0qM {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.Social-module__secondary-border___hfcte {
  border: 1px solid #637768;
}

.Social-module__secondary-border-b___jIuED {
  border-bottom: 1px solid #637768;
}

.Social-module__secondary-border-t___eCPKF {
  border-top: 1px solid #637768;
}

.Social-module__secondary-border-l___nFZWp {
  border-left: 1px solid #637768;
}

.Social-module__secondary-border-r___g_ze7 {
  border-right: 1px solid #637768;
}

.Social-module__gap-0___Vbrjf {
  gap: 0 !important;
}

.Social-module__gap-2___kuOem {
  gap: 2px !important;
}

.Social-module__gap-4___TtUrC {
  gap: 4px !important;
}

.Social-module__gap-5___Mhx2k {
  gap: 5px !important;
}

.Social-module__gap-6___plQ6I {
  gap: 6px !important;
}

.Social-module__gap-8___eNWsG {
  gap: 8px !important;
}

.Social-module__gap-10___KmUDM {
  gap: 10px !important;
}

.Social-module__gap-12___njUbO {
  gap: 12px !important;
}

.Social-module__gap-14___mwmFu {
  gap: 14px !important;
}

.Social-module__gap-16___bOT_t {
  gap: 16px !important;
}

.Social-module__gap-18___QboM8 {
  gap: 18px !important;
}

.Social-module__gap-20___rqBZZ {
  gap: 20px !important;
}

.Social-module__gap-24___UL8yi {
  gap: 24px !important;
}

.Social-module__gap-26___RotSp {
  gap: 26px !important;
}

.Social-module__gap-30___Bqzid {
  gap: 30px !important;
}

.Social-module__gap-32___HDGxr {
  gap: 32px !important;
}

.Social-module__gap-40___k19zn {
  gap: 40px !important;
}

.Social-module__gap-50___AuFoO {
  gap: 50px !important;
}

.Social-module__flex-1___zwHFe {
  flex: 1;
}

.Social-module__flex-none___ITfJv {
  flex: none !important;
}

.Social-module__flex-column___W4870 {
  display: flex;
  flex-direction: column !important;
}

.Social-module__flex-row___OK4Nc {
  display: flex;
  flex-direction: row !important;
}

.Social-module__vertically-centered___lq4oG {
  display: flex;
  align-items: center !important;
}

.Social-module__horizontally-centered___nzrjV {
  display: flex;
  justify-content: center !important;
}

.Social-module__horizontally-end___yVZpv {
  display: flex;
  justify-content: end !important;
}

.Social-module__vertically-start___FZ56q {
  display: flex;
  align-items: start !important;
}

.Social-module__space-between___QU99C {
  display: flex;
  justify-content: space-between !important;
}

.Social-module__flex-wrap___QrE2U {
  flex-wrap: wrap !important;
}

.Social-module__height-100___EHNc4 {
  height: 100%;
}

.Social-module__width-50____ZUuH {
  width: 50% !important;
}

.Social-module__width-100___FO3G0 {
  width: 100%;
}

.Social-module__cursor-pointer___duVxW {
  cursor: pointer;
}

.Social-module__cursor-not-allowed___FHktu {
  cursor: not-allowed !important;
}

.Social-module__absolute-centered___v3pzO {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.Social-module__absolute___jJbO3 {
  position: absolute;
}

.Social-module__relative___EMsvr {
  position: relative;
}

.Social-module__fixed___p6ZyG {
  position: fixed;
}

.Social-module__visible___H4Ylt {
  opacity: 1;
}

.Social-module__invisible___l5GsT {
  opacity: 0;
}

.Social-module__col-90___sx3nW {
  width: 90% !important;
}

.Social-module__col-auto___SYULB {
  width: auto !important;
}

.Social-module__medical-tabs___DqleG {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.Social-module__medical-table-new___L_etF {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.Social-module__medical-table-new___L_etF:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.Social-module__medical-table-new___L_etF::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.Social-module__medical-table-new___L_etF::-webkit-scrollbar-track {
  display: none;
}
.Social-module__medical-table-new___L_etF.Social-module__no-pagination___iLpgP {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.Social-module__medical-table-new___L_etF.Social-module__no-pagination___iLpgP:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.Social-module__medical-table-new___L_etF.Social-module__no-pagination___iLpgP::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.Social-module__medical-table-new___L_etF.Social-module__no-pagination___iLpgP::-webkit-scrollbar-track {
  display: none;
}

.Social-module__medical-table-empty___ZgsnK {
  padding: 14px 40px !important;
}

.Social-module__icon-btn___QAvA6 {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.Social-module__search-icon___CmfLb {
  width: 24px;
  height: 24px;
  align-self: center;
}

.Social-module__disable-select___jQWu0 {
  user-select: none;
}

.Social-module__break-word___NTY0T {
  word-break: break-word;
}

.Social-module__popup-clear-btn___SiCEF {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.Social-module__scroll-m-b-20___CqIss {
  scroll-margin-bottom: 20px;
}

.Social-module__article___izhAu {
  height: calc(100vh - var(--top-navigation) - var(--patient-details-header) - var(--patient-details-footer));
  overflow-y: scroll;
  overflow-x: hidden;
}
.Social-module__article___izhAu:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.Social-module__article___izhAu::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.Social-module__article___izhAu::-webkit-scrollbar-track {
  display: none;
}
.Social-module__article___izhAu .Social-module__content___jYy70 {
  margin: 18px 21px;
  width: 60%;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/pages/PatientDetails/fragments/Social/Social.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;ECQE,2GDNE;ECOF,kBAAA;EACA,kBAAA;ADupBF;ACrpBE;EACE,oCAAA;EACA,mBAAA;ADupBJ;ACppBE;EACE,UAAA;EACA,6BAAA;ADspBJ;ACnpBE;EACE,aAAA;ADqpBJ;AArqBE;EACE,iBAAA;EACA,UAAA;AAuqBJ","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.article {\n  @include verticalScroll(\n    calc(\n      100vh - var(--top-navigation) - var(--patient-details-header) - var(--patient-details-footer)\n    )\n  );\n\n  .content {\n    margin: 18px 21px;\n    width: 60%;\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `Social-module__font-s-10___VR9Mg`,
	"fontS12": `Social-module__font-s-12___ki1k9`,
	"fontS13": `Social-module__font-s-13___S_zj2`,
	"fontS14": `Social-module__font-s-14___B6ANJ`,
	"fontS15": `Social-module__font-s-15___fsEM9`,
	"fontS16": `Social-module__font-s-16___WRtI1`,
	"fontS18": `Social-module__font-s-18___QOOOi`,
	"fontS20": `Social-module__font-s-20___yw2wv`,
	"fontS22": `Social-module__font-s-22___BmeVY`,
	"fontS28": `Social-module__font-s-28___k9TCS`,
	"fontW400": `Social-module__font-w-400___FAZZS`,
	"fontW500": `Social-module__font-w-500___DqlK9`,
	"fontW600": `Social-module__font-w-600___wh0_l`,
	"fontW700": `Social-module__font-w-700___Q9PTm`,
	"p5": `Social-module__p-5___B3wsu`,
	"p12": `Social-module__p-12___LbvDX`,
	"p16": `Social-module__p-16___BBlqH`,
	"p30": `Social-module__p-30___t5NWZ`,
	"pB0": `Social-module__p-b-0___AQouN`,
	"pB5": `Social-module__p-b-5___hjoPV`,
	"pB10": `Social-module__p-b-10___LFOxA`,
	"pB12": `Social-module__p-b-12___x8fLj`,
	"pB16": `Social-module__p-b-16___h7uLQ`,
	"pB18": `Social-module__p-b-18___KA25L`,
	"pB20": `Social-module__p-b-20___Ie3kF`,
	"pB25": `Social-module__p-b-25___YN2yV`,
	"pB30": `Social-module__p-b-30___JfPwB`,
	"pB50": `Social-module__p-b-50___gudsi`,
	"pT0": `Social-module__p-t-0___HfJN1`,
	"pT12": `Social-module__p-t-12___idW5R`,
	"pT16": `Social-module__p-t-16___pUpMv`,
	"pT18": `Social-module__p-t-18___O5i5L`,
	"pT20": `Social-module__p-t-20___ZkuHf`,
	"pT30": `Social-module__p-t-30___B5y15`,
	"pT40": `Social-module__p-t-40___WhVOJ`,
	"pT50": `Social-module__p-t-50___AMwpL`,
	"pL20": `Social-module__p-l-20___ML1Qb`,
	"pL30": `Social-module__p-l-30___NYTW1`,
	"pL40": `Social-module__p-l-40___FywCN`,
	"pR16": `Social-module__p-r-16___PuFRt`,
	"pR20": `Social-module__p-r-20___YfENY`,
	"pR30": `Social-module__p-r-30___Da4fQ`,
	"pR50": `Social-module__p-r-50___rwzgc`,
	"pR60": `Social-module__p-r-60___G8KQ5`,
	"mB1": `Social-module__m-b-1___pFkN4`,
	"mB2": `Social-module__m-b-2___WQSrU`,
	"mB6": `Social-module__m-b-6___epfm7`,
	"mB8": `Social-module__m-b-8___z0wDl`,
	"mB10": `Social-module__m-b-10___jpIX0`,
	"mB14": `Social-module__m-b-14___EfpZ3`,
	"mB16": `Social-module__m-b-16___Yj1Xm`,
	"mB20": `Social-module__m-b-20___jfKqX`,
	"mB22": `Social-module__m-b-22___JHKEX`,
	"mB24": `Social-module__m-b-24___zZvmY`,
	"mB30": `Social-module__m-b-30___zqNKu`,
	"mB32": `Social-module__m-b-32___GVWEk`,
	"mB40": `Social-module__m-b-40___vhfLM`,
	"mT2": `Social-module__m-t-2___a8UrR`,
	"mT3": `Social-module__m-t-3___tOXya`,
	"mT4": `Social-module__m-t-4___SN3bl`,
	"mT5": `Social-module__m-t-5___U5kWv`,
	"mT8": `Social-module__m-t-8___IFngg`,
	"mT10": `Social-module__m-t-10___KtiIK`,
	"mT15": `Social-module__m-t-15___Eca0V`,
	"mT16": `Social-module__m-t-16___IJq2C`,
	"mT20": `Social-module__m-t-20___VZagB`,
	"mT22": `Social-module__m-t-22___jA9D6`,
	"mT30": `Social-module__m-t-30___HSeAV`,
	"mT32": `Social-module__m-t-32___WIbEG`,
	"mLAuto": `Social-module__m-l-auto___bLJwC`,
	"mL4": `Social-module__m-l-4___Ah_8f`,
	"mL5": `Social-module__m-l-5___bE4Sj`,
	"mL6": `Social-module__m-l-6___iiLe0`,
	"mL8": `Social-module__m-l-8___VK6BS`,
	"mL10": `Social-module__m-l-10___v9JJI`,
	"mL16": `Social-module__m-l-16___qfbvU`,
	"mL20": `Social-module__m-l-20___hIUaq`,
	"mL24": `Social-module__m-l-24___cSa87`,
	"mL30": `Social-module__m-l-30___vOX9A`,
	"mL35": `Social-module__m-l-35___VSkEM`,
	"mL40": `Social-module__m-l-40___hrwmu`,
	"mR8": `Social-module__m-r-8___Tk5YJ`,
	"mR10": `Social-module__m-r-10___ujXVM`,
	"mR16": `Social-module__m-r-16___wcyv9`,
	"mR20": `Social-module__m-r-20___fHtXR`,
	"mR24": `Social-module__m-r-24___hcOsX`,
	"mR30": `Social-module__m-r-30___PqnDl`,
	"mR40": `Social-module__m-r-40___oYxhH`,
	"borderR3": `Social-module__border-r-3___WcB8J`,
	"borderR4": `Social-module__border-r-4___uUjeb`,
	"borderR6": `Social-module__border-r-6___Iacj0`,
	"borderR10": `Social-module__border-r-10___zN6hX`,
	"borderR12": `Social-module__border-r-12___ZJ2To`,
	"borderR16": `Social-module__border-r-16___OKFpl`,
	"borderR50": `Social-module__border-r-50___FpW9u`,
	"primaryBorder": `Social-module__primary-border___QeYc1`,
	"primaryBorderB": `Social-module__primary-border-b___v4gEe`,
	"primaryBorderT": `Social-module__primary-border-t___jOwru`,
	"primaryBorderL": `Social-module__primary-border-l___JsPEr`,
	"primaryBorderR": `Social-module__primary-border-r___yN0qM`,
	"secondaryBorder": `Social-module__secondary-border___hfcte`,
	"secondaryBorderB": `Social-module__secondary-border-b___jIuED`,
	"secondaryBorderT": `Social-module__secondary-border-t___eCPKF`,
	"secondaryBorderL": `Social-module__secondary-border-l___nFZWp`,
	"secondaryBorderR": `Social-module__secondary-border-r___g_ze7`,
	"gap0": `Social-module__gap-0___Vbrjf`,
	"gap2": `Social-module__gap-2___kuOem`,
	"gap4": `Social-module__gap-4___TtUrC`,
	"gap5": `Social-module__gap-5___Mhx2k`,
	"gap6": `Social-module__gap-6___plQ6I`,
	"gap8": `Social-module__gap-8___eNWsG`,
	"gap10": `Social-module__gap-10___KmUDM`,
	"gap12": `Social-module__gap-12___njUbO`,
	"gap14": `Social-module__gap-14___mwmFu`,
	"gap16": `Social-module__gap-16___bOT_t`,
	"gap18": `Social-module__gap-18___QboM8`,
	"gap20": `Social-module__gap-20___rqBZZ`,
	"gap24": `Social-module__gap-24___UL8yi`,
	"gap26": `Social-module__gap-26___RotSp`,
	"gap30": `Social-module__gap-30___Bqzid`,
	"gap32": `Social-module__gap-32___HDGxr`,
	"gap40": `Social-module__gap-40___k19zn`,
	"gap50": `Social-module__gap-50___AuFoO`,
	"flex1": `Social-module__flex-1___zwHFe`,
	"flexNone": `Social-module__flex-none___ITfJv`,
	"flexColumn": `Social-module__flex-column___W4870`,
	"flexRow": `Social-module__flex-row___OK4Nc`,
	"verticallyCentered": `Social-module__vertically-centered___lq4oG`,
	"horizontallyCentered": `Social-module__horizontally-centered___nzrjV`,
	"horizontallyEnd": `Social-module__horizontally-end___yVZpv`,
	"verticallyStart": `Social-module__vertically-start___FZ56q`,
	"spaceBetween": `Social-module__space-between___QU99C`,
	"flexWrap": `Social-module__flex-wrap___QrE2U`,
	"height100": `Social-module__height-100___EHNc4`,
	"width50": `Social-module__width-50____ZUuH`,
	"width100": `Social-module__width-100___FO3G0`,
	"cursorPointer": `Social-module__cursor-pointer___duVxW`,
	"cursorNotAllowed": `Social-module__cursor-not-allowed___FHktu`,
	"absoluteCentered": `Social-module__absolute-centered___v3pzO`,
	"absolute": `Social-module__absolute___jJbO3`,
	"relative": `Social-module__relative___EMsvr`,
	"fixed": `Social-module__fixed___p6ZyG`,
	"visible": `Social-module__visible___H4Ylt`,
	"invisible": `Social-module__invisible___l5GsT`,
	"col90": `Social-module__col-90___sx3nW`,
	"colAuto": `Social-module__col-auto___SYULB`,
	"medicalTabs": `Social-module__medical-tabs___DqleG`,
	"medicalTableNew": `Social-module__medical-table-new___L_etF`,
	"noPagination": `Social-module__no-pagination___iLpgP`,
	"medicalTableEmpty": `Social-module__medical-table-empty___ZgsnK`,
	"iconBtn": `Social-module__icon-btn___QAvA6`,
	"searchIcon": `Social-module__search-icon___CmfLb`,
	"disableSelect": `Social-module__disable-select___jQWu0`,
	"breakWord": `Social-module__break-word___NTY0T`,
	"popupClearBtn": `Social-module__popup-clear-btn___SiCEF`,
	"scrollMB20": `Social-module__scroll-m-b-20___CqIss`,
	"article": `Social-module__article___izhAu`,
	"content": `Social-module__content___jYy70`
};
module.exports = ___CSS_LOADER_EXPORT___;
